import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Dialog } from '@headlessui/react'

import { facilityFilterFacilityGroup } from '../../../actions/facilitiesActions'

import * as AppConstants from '../../../utils/constants'
import reserveApi from '../../../utils/axios'
import camelcaseKeys from 'camelcase-keys'
import FacilityGroupActive from './Active.jsx'

const connected = connect(store => {
  return {}
})

const FacilityGroupFilter = ({ dispatch, open, onClose }) => {
  const [facilityGroups, setFacilityGroups] = useState([])

  useEffect(() => {
    reserveApi({
      method: 'get',
      url: '/facility_groups',
      params: {}
    }).then(response => {
      setFacilityGroups(camelcaseKeys(response.data, { deep: true }))
    })
  }, [])

  const handleFacilityGroupClick = facilityGroup => {
    dispatch(facilityFilterFacilityGroup(facilityGroup))
    onClose()
  }
  return (
    <>
      <FacilityGroupActive />

      <Dialog open={open} className="fixed inset-0 z-[51] mx-2 overflow-y-auto" onClose={() => onClose()}>
        <div className="flex items-center justify-center min-h-screen">
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />

          <div className="inline-block w-full max-w-4xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg">
            <div className="flex bg-gray-200 px-4 py-3 sm:px-6 ">
              <Dialog.Title className="flex-grow self-center text-xl font-semibold text-gray-900">
                Filter by:
              </Dialog.Title>

              <div className="flex-initial self-center">
                <button
                  type="button"
                  className="bg-gray-700 text-white font-semibold p-1 rounded-md"
                  onClick={() => onClose()}
                >
                  <span className="hidden md:inline">Close</span>
                  <span className="inline md:hidden">Close</span>
                </button>
              </div>
            </div>
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="grid grid-flow-col grid-rows-3 gap-2">
                {Object.entries(AppConstants.STATES).map(([abbrv, usState], i) => (
                  <div key={abbrv} className="inline-block">
                    <span className="hidden md:inline">{usState}</span>
                    <span className="inline md:hidden">{abbrv}</span>
                  </div>
                ))}
              </div>

              <div>
                <div className="font-semibold mt-8 mb-2 border-b border-gray-200">Popular:</div>
                <div className="">
                  {facilityGroups
                    .sort((a, b) => a.activeRequestCount > b.activeRequestCount)
                    .splice(0, 10)
                    .map(facilityGroup => (
                      <div key={`sort_${facilityGroup.id}`} className="truncate overflow-hidden">
                        <button onClick={() => handleFacilityGroupClick(facilityGroup)} type="button">
                          {facilityGroup.name}
                        </button>
                      </div>
                    ))}
                </div>
              </div>
              <div>
                <div className="font-semibold mt-8 mb-2 border-b border-gray-200">Browse All:</div>
                <div className="">
                  {facilityGroups.map(facilityGroup => (
                    <div key={facilityGroup.id} className="truncate overflow-hidden">
                      <button onClick={() => handleFacilityGroupClick(facilityGroup)} type="button">
                        {facilityGroup.name}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default connected(FacilityGroupFilter)
